<template>
  <div class="topNav plr flex align-center" :class="[(isFixTop||isMobile||isTablet)?'fix-top':'']">
    <div class="logo-block">
      <img v-if="langZh" src="@/assets/logo2.png" alt="" class="logo" @click="toIndexPage">
      <img v-else src="@/assets/logo.png" alt="" class="logoEn" @click="toIndexPage">
    </div>
    <div class="menu-block">
      <navMenu v-show="isDesktop||isRowTablet"></navMenu>
      <mobileMenu :menu-show="clickPhoneMenuIcon" @closeMobileMenu="clickPhoneMenuIcon=false"></mobileMenu>

      <div class="operation-block flex align-center"
      >

<!--        &lt;!&ndash; 右侧搜索区域 &ndash;&gt;-->
<!--        <div class="right-search" ref="searchContainer">-->
<!--          <div class="search-wrapper" :class="{ 'expanded': isSearchExpanded }">-->
<!--            <input-->
<!--                ref="searchInput"-->
<!--                type="text"-->
<!--                class="search-input"-->
<!--                v-model="searchQuery"-->
<!--                placeholder="请输入搜索的关键词"-->
<!--                :style="{ width: isSearchExpanded ? '130px' : '0' }"-->
<!--                @blur="handleBlur"-->
<!--                @keyup.enter="handleSearch"-->
<!--            />-->

<!--            <div class="search-icon-container" @click="toggleSearch">-->
<!--              <img class="search-icon-img " src="@/assets/images/search-icon.svg" alt=""/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div class="language" v-if="isDesktop||isRowTablet">
          <el-select v-model="language" :placeholder="$t('qing-xuan-ze-yu-yan')" @change="handleSelect">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
            <img slot="prefix" :src="require('@/assets/images/语言.svg')" alt=""/>
          </el-select>
        </div>
        <!--        手机平板端添加图标，点击展示汉堡菜单-->
        <div class="phone-block flex align-center" v-if="isMobile||isTablet">
          <img v-if="!clickPhoneMenuIcon" src="@/assets/images/appMenu.svg" alt="" @click="toggleMenu">
          <img v-else src="@/assets/images/closeMenu.svg" alt="" @click="toggleMenu">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {changeLanguage} from '@/api'
import deviceMixin from '@/mixins/device'

export default {
  mixins: [deviceMixin],
  components: {
    navMenu:() => import('./navMenu'),
    mobileMenu:()=>import('./mobileMenu')
  },
  data() {
    return {
      isFixTop: true,
      clickPhoneMenuIcon: false,
      menuList: [],
      isSearchExpanded: false,
      searchInputVisible: false,
      searchQuery: '',
      language: sessionStorage.getItem('lang') || 'zh_CN',
      options: [
        {
          value: 'zh_CN',
          label: '中文'
        },
        {
          value: 'en',
          label: 'English'
        }
      ]
    }
  },
  watch: {
    '$route': {
      handler() {
        const fullPath = this.$route.fullPath
        if (fullPath.includes('about')) {
          this.isFixTop = false
        } else {
          this.isFixTop = true
        }
      },
      immediate: true
    },
  },
  created() {
    // this.init(this.language)
  },
  computed:{
    langZh() {
      return this.$i18n.locale === 'zh_CN'
    }
  },
  methods: {
    toggleMenu() {
      this.clickPhoneMenuIcon = !this.clickPhoneMenuIcon
    },
    async handleSelect(key, keyPath) {
      // console.log('select-key', key)
      // console.log('select-keyPath', keyPath)
      //  输出的keyPath为组件绑定的index值
      //  当绑定menu.index时，输出数字（字符串）数组
      //  当绑定menu.path时，输出路径（字符串）数组

      if (key === 'en') {
        await changeLanguage('en_US')
      } else {
        await changeLanguage('zh_CN')
      }
      location.reload()
      this.$i18n.locale = key;
      sessionStorage.setItem('lang', key)
      this.$emit('changeLang', key)
    },
    init(key) {
      this.$i18n.locale = key;
      sessionStorage.setItem('lang', key)
      this.$emit('changeLang', key)
      if (key === 'en') {
        changeLanguage('en_US')
      } else {
        changeLanguage('zh_CN')
      }
    },
    //点击logo
    toIndexPage() {
      this.$router.push({path: '/index'})
    },

    // toggleSearch() {
    //   this.isSearchExpanded = !this.isSearchExpanded;
    //   if (this.isSearchExpanded) {
    //     this.$nextTick(() => {
    //       this.$refs.searchInput.focus();
    //     });
    //   }
    // },

    // handleBlur() {
    //   // 延迟收起，避免点击图标时立即收起
    //   setTimeout(() => {
    //     this.isSearchExpanded = false;
    //   }, 200);
    // },
    // handleSearch() {
    //   if (this.searchQuery.trim()) {
    //     console.log('搜索关键词:', this.searchQuery);
    //     // 这里可以触发搜索逻辑
    //     this.$emit('search', this.searchQuery);
    //   }
    //   this.$refs.searchInput.blur();
    // }
  },

}
</script>

<style scoped lang="scss">
.topNav {
  //padding: 0 208px;
  height: 80px;
  background: rgba(255, 255, 255, 0.80);
  box-shadow: 0 4px 16px 0 rgba(53, 65, 88, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  //backdrop-filter: blur(17.5px);
  @media (max-width: 1024px) {
  }
}

.fix-top {
  position: fixed;
  background: #ffffff;
  z-index: 999;
  top: 0;
  width: 80%;
  @media screen and (max-width: 1024px) {
    width: calc(100% - 40px);
  }
}

.logo-block {
  margin-right: 8%;
  cursor: pointer;
  display: flex;
  align-items: center;

  .logo {
    width: 243px;
    height: 26px;
  }
  .logoEn{
    width: 180px;
    height:26px;
  }
}

@media (max-width: 1500px) {
  .logo-block {
    margin-right: 0;

    .logo {
      width: 168px;
      height: 18px;
    }
    .logoEn{
      width: 130px;
      height: 18px;
    }
  }
}

.menu-block {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.operation-block {
  gap: 24px;
  justify-content: flex-end;
  position: relative;
  flex: 1;
  @media(min-width: 1024px) and (max-width: 1500px) {
    gap: 8px;
  }

  ::v-deep .language {
    width: 120px;
    position: relative;
    right: 0;
    display: flex;
    align-items: center;


    .el-input__inner {
      border: none;
    }

    .el-input__prefix {
      display: flex;
      align-items: center;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .el-input__suffix {
      .el-icon-arrow-up:before {
        content: none;
      }
    }

    ::v-deep .el-input--prefix .el-input__inner {
      padding-left: 25px;
    }

  }
}

::v-deep .el-select-dropdown .el-select-dropdown__list .selected {
  color: #1C277F !important;
}

.right-search {
  position: relative;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
}

.search-input {
  height: 40px;
  padding: 0 45px 0 15px;
  border: 1px solid #E8E8E8;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(10px);
}

.search-wrapper.expanded .search-input {
  opacity: 1;
  transform: translateX(0);
}

.search-icon-container {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 2;
}

.search-icon-container:hover {
  background: white;
  //transform: scale(1.05);
}

.search-icon-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.search-wrapper.expanded .search-icon-container {
  right: 0;
  //background: #667eea;
}

@media screen and (max-width: 1024px) {
  .topNav {
    padding: 0 20px;
  }
  .menu-block {

  }
}

::v-deep .operation-block .language .el-input__inner {
  padding-right: 0;
}

@media screen and (max-width: 1024px) {
  .phone-block {
    img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
